import React from "react";
import Features from "../components/Features";

export default function ForeignCurrency() {
  return (
    <div className="foreign-currency-page">
      {/* HERO SECTION */}
      <section className="fc-hero">
        <div className="fc-left">
          <h1>Foreign Currency Accounts</h1>
          <p>
            Manage your global finances seamlessly with a Swiss-grade
            multi-currency account. Hold, transfer, and receive funds in USD, EUR,
            GBP, CHF, and other major currencies — all from one secure platform.
          </p>
          <p>
            Whether you're a frequent traveler, an international entrepreneur, or
            an investor with cross-border interests, our foreign currency accounts
            simplify your global transactions with minimal FX conversion costs and
            transparent exchange rates.
          </p>
        </div>
        <div className="fc-right">
          <img src="/service5.png" alt="Foreign Currency Accounts" />
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="fc-details">
        <h2>Why Choose Our Foreign Currency Accounts?</h2>
        <p>
          Our Swiss-backed offshore accounts are built for flexibility and security.
          You gain instant access to your funds across the globe while benefiting from
          the trusted precision and privacy of Swiss banking.
        </p>
        <ul>
          <li>✅ Hold and manage multiple currencies from one account</li>
          <li>✅ Zero hidden FX margins or conversion traps</li>
          <li>✅ Ideal for global citizens, expats, and businesses</li>
          <li>✅ Protected under international financial regulations</li>
        </ul>
      </section>

      {/* FEATURES SECTION */}
      <Features />
    </div>
  );
}

/* ---------------------- CSS BELOW ---------------------- */

const styles = `
.foreign-currency-page {
  background: #f9fafc;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  padding-bottom: 60px;
}

.fc-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 10%;
  gap: 40px;
  background: white;
}

.fc-left {
  flex: 1;
}

.fc-left h1 {
  font-size: 2.5rem;
  color: #c21c2b;
  margin-bottom: 20px;
}

.fc-left p {
  margin-bottom: 15px;
  font-size: 1.05rem;
  color: #333;
}

.fc-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.fc-right img {
  width: 90%;
  max-width: 500px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

.fc-details {
  padding: 60px 10%;
  max-width: 1000px;
  margin: 0 auto;
}

.fc-details h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #111;
}

.fc-details p {
  margin-bottom: 20px;
  color: #444;
}

.fc-details ul {
  list-style: none;
  padding-left: 0;
}

.fc-details li {
  margin-bottom: 10px;
  font-size: 1rem;
}

@media (max-width: 900px) {
  .fc-hero {
    flex-direction: column;
  }
  .fc-right img {
    width: 100%;
  }
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
